export const APP_NAME = "ThreatModeling.studio";
export const APP_TAGLINE = "Threat modeling simple, colaborativo y escalable.";
export const APP_DESCRIPTION = "ThreatModeling.studio acelera el modelado de amenazas con IA para que los equipos detecten riesgos antes, prioricen mejor y entreguen software más seguro.";
export const FOOTER_LABEL = APP_NAME;
export const FOOTER_URL = "https://threatmodeling.studio";
export const APP_THEME_COLOR = "#4338ca";